import React from "react";
import { cn } from "@/lib/utils";
import { usePagerContext } from "../lib/providers/pager-context";
import { getSlideNumber } from "../lib/field-path";
import { useSelection } from "../lib/hooks/use-selection";
import { useSelectionContext } from "../lib/providers/selection-context";

export function PageLayout({
  children,
  fieldName,
  className,
}: {
  children: React.ReactNode;
  fieldName: string;
  className?: string;
}) {
  const { setCurrentPage } = usePagerContext();
  const { setCurrentSelection } = useSelectionContext();
  const pageNumber = getSlideNumber(fieldName);

  return (
    <div
      className={cn(
        "flex flex-col justify-start grow w-full",
        "min-h-[calc(100%-80px)]", // Leave space for footer
        className
      )}
      onClick={(event) => {
        setCurrentPage(pageNumber);
        setCurrentSelection(fieldName, event);
      }}
    >
      {children}
    </div>
  );
}
